import SEOHead from '@/components/SEOHead';
import InstallHeroV2 from '@/components/marketing/install/v2/InstallHeroV2';
import InstallOsGuideV2 from '@/components/marketing/install/v2/InstallOsGuideV2';
import InstallWhySafeV2 from '@/components/marketing/install/v2/InstallWhySafeV2';
import InstallFaqV2 from '@/components/marketing/install/v2/InstallFaqV2';
import { FinalCtaSection } from '@/components/marketing/v2/FinalCtaSection';

export default function InstallGuide() {
  return (
    <>
      <SEOHead
        title="Guide d'installation — Velko POS Desktop (Windows, macOS, Linux)"
        description="Comment installer l'app Velko POS sur macOS, Windows et Linux : contourner Gatekeeper (commande xattr), SmartScreen Windows, et lancer l'AppImage Linux. Étapes pas à pas."
        path="/guide-installation"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: "Guide d'installation", path: '/guide-installation' },
        ]}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'HowTo',
          name: "Installer Velko POS sur ordinateur",
          description:
            "Installer l'application desktop Velko POS sur macOS, Windows ou Linux malgré l'avertissement de sécurité (app non encore notarisée).",
          step: [
            {
              '@type': 'HowToStep',
              name: 'macOS',
              text: 'Télécharge le .dmg, glisse l\'app dans Applications, puis fais un clic droit → Ouvrir ou exécute « xattr -d com.apple.quarantine "/Applications/Velko POS.app" ».',
            },
            {
              '@type': 'HowToStep',
              name: 'Windows',
              text: 'Lance le .exe, puis dans SmartScreen clique « Informations complémentaires » → « Exécuter quand même ».',
            },
            {
              '@type': 'HowToStep',
              name: 'Linux',
              text: 'Rends l\'AppImage exécutable (chmod +x) puis lance-la, ou installe le paquet .deb / .rpm.',
            },
          ],
        }}
      />

      <InstallHeroV2 />
      <InstallOsGuideV2 />
      <InstallWhySafeV2 />
      <InstallFaqV2 />
      <FinalCtaSection
        eyebrow="Pas encore téléchargé ?"
        title="Récupère l'app."
        highlight="Installe en 30 s."
        subtitle="Choisis ta plateforme sur la page de téléchargement, reviens ici si ton système affiche un avertissement, et tu es prêt à encaisser."
        primaryLabel="Voir les téléchargements"
        primaryTo="/telechargement"
        secondaryLabel="Créer un compte gratuit"
        secondaryTo="/register"
        guarantees={['Web · Desktop · Android', 'Open-source vérifiable', 'Support FR']}
      />
    </>
  );
}
